<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-form-item label="金额（元）:">
                        <el-input v-model="table.where.title_unit" placeholder="请输入金额（元）" clearable />
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <el-input-number v-model="table.where.phone" placeholder="请输入手机号" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="标题:">
                        <el-input v-model="table.where.title" placeholder="请输入标题" clearable />
                    </el-form-item>
                    <el-form-item label="商城数量:">
                        <el-input-number v-model="table.where.store_num" placeholder="请输入商城数量" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-select v-model="table.where.status" filterable placeholder="请选择">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-select v-model="table.where.show_status" filterable placeholder="请选择">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="隐藏" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态:">
                        <el-select v-model="table.where.siteswitch" filterable placeholder="请选择">
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="正常" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="小数输入框:">
                        <el-input-number v-model="table.where.flot_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入小数输入框"
                            clearable />
                    </el-form-item>

                    <el-form-item label="时间选择器:">
                        <el-time-picker is-range v-model="table.where.datetime" range-separator="至"
                            start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"
                            value-format="hh:mm:ss">
                        </el-time-picker>
                    </el-form-item>

                    <el-form-item label="日期组件:">
                        <el-date-picker v-model="table.where.date_info" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="日期时间组件:">
                        <el-date-picker v-model="table.where.timestamp" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="时间日期其他:">
                        <el-date-picker v-model="table.where.datetimessss" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="会员id单选:">
                        <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="多id合集:">
                        <el-select v-model="table.where.user_ids" multiple filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="管理员id:">
                        <el-select v-model="table.where.admin_id" filterable placeholder="请选择">
                            <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname+item.mobile"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="管理员id多选:">
                        <el-select v-model="table.where.admin_ids" multiple filterable placeholder="请选择">
                            <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname+item.mobile"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="关联表id:">
                        <el-select v-model="table.where.store_goods_category_id" filterable placeholder="请选择">

                            <el-option v-for="item in store_goods_category_list" :key="item.id" :label="item.cate_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="分类时间:">
                        <el-select v-model="table.where.store_goods_category_time_id" filterable placeholder="请选择">

                            <el-option v-for="item in store_goods_category_list" :key="item.id" :label="item.add_time"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关联表id多选:">
                        <el-select v-model="table.where.store_goods_category_ids" multiple filterable placeholder="请选择">
                            <el-option v-for="item in store_goods_category_list" :key="item.id" :label="item.cate_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="权重:">
                        <el-input-number v-model="table.where.sort" placeholder="请输入权重" :controls="false"
                            controls-position="right" class="ele-fluid ele-text-left" clearable />
                    </el-form-item>
                    <el-form-item label="单选:">
                        <el-select v-model="table.where.timelist" filterable placeholder="请选择">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="多选下拉:">
                        <el-select v-model="table.where.timeslist" multiple filterable placeholder="请选择">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="单选:">
                        <el-select v-model="table.where.hobbydata" filterable placeholder="请选择">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="多选:">
                        <el-select v-model="table.where.hobbysdata" multiple filterable placeholder="请选择">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="隐藏" value="0"></el-option>
                            <el-option label="推荐" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="金额小数:">
                        <el-input-number v-model="table.where.decimal_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入金额小数"
                            clearable />
                    </el-form-item>

                    <el-form-item label="地区选址:">
                        <el-cascader v-model="table.where.address_region" :options="cityData.cityDataLabel" clearable
                            popper-class="ele-pop-wrap-higher" :props="{ checkStrictly: true }" />
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>



                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:ceshi:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->

            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:ceshi:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:ceshi:dall')">批量删除
                </el-button>
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />
                    <el-table-column prop="title_unit" label="金额（元）" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="phone" label="手机号" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="title" label="标题" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="store_num" label="商城数量" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.status" @change="editStatus(row,'status')" :active-value="1"
                                :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="show_status" label="状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.show_status" @change="editStatus(row,'show_status')"
                                :active-value="1" :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="siteswitch" label="状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.siteswitch" @change="editStatus(row,'siteswitch')" :active-value="1"
                                :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="flot_price" label="小数输入框" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="datetime" label="时间选择器" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="date_info" label="日期组件" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="timestamp" label="日期时间组件" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="datetimessss" label="时间日期其他" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="user_id" label="会员id单选" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.user_id_info" :key="index">{{item.nick_name+item.phone}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_ids" label="多id合集" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.user_ids_info" :key="index">{{item.nick_name+item.phone}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="admin_id" label="管理员id" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.admin_id_info" :key="index">{{item.realname+item.mobile}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="admin_ids" label="管理员id多选" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.admin_ids_info" :key="index">
                                {{item.realname+item.mobile}}</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="store_goods_category_id" label="关联表id" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.store_goods_category_id_info" :key="index">
                                {{item.cate_name}}</el-tag>
                        </template>
                    </el-table-column>



                    <el-table-column prop="store_goods_category_time_id" label="分类时间" show-overflow-tooltip
                        min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.store_goods_category_time_id_info" :key="index">
                                {{item.add_time}}</el-tag>
                        </template>
                    </el-table-column>


                    <el-table-column prop="store_goods_category_ids" label="关联表id多选" show-overflow-tooltip
                        min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.store_goods_category_ids_info" :key="index">
                                {{item.cate_name}}</el-tag>
                        </template>
                    </el-table-column>



                    <el-table-column prop="sort" label="权重" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="smallimage" label="单图" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-image style="width: 50px; height: 50px" :src="row.smallimage"
                                :preview-src-list="[row.smallimage]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="smallimages" label="多图" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-image v-for="(item,index) in row.smallimages" :key="index"
                                style="width: 50px; height: 50px" :src="item" :preview-src-list="row.smallimages">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="attachfile" label="单文件" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <a :href="row.attachfile" target="_blank">
                                <el-tag>文件</el-tag>
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="attachfiles" label="多文件" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <a v-for="(item,index) in row.attachfiles" :key="index" :href="item" target="_blank">
                                <el-tag>文件{{index+1}}</el-tag>
                            </a>
                        </template>
                    </el-table-column>

                    <el-table-column prop="miniavatar" label="当头像" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-image style="width: 50px; height: 50px" :src="row.miniavatar"
                                :preview-src-list="[row.miniavatar]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="miniavatars" label="多头像" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-image v-for="(item,index) in row.miniavatars" :key="index"
                                style="width: 50px; height: 50px" :src="item" :preview-src-list="row.miniavatars">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="timelist" label="单选" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.timelist == 1" :key="index">正常</el-tag>
                            <el-tag v-if="row.timelist == 0" :key="index">隐藏</el-tag>
                            <el-tag v-if="row.timelist == 2" :key="index">推荐</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="timeslist" label="多选下拉" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <span v-for="(item,index) in row.timeslist" :key="index">
                                <el-tag v-if="item == 1" :key="index">正常</el-tag>
                                <el-tag v-if="item == 0" :key="index">隐藏</el-tag>
                                <el-tag v-if="item == 2" :key="index">推荐</el-tag>
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="hobbydata" label="单选" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.hobbydata == 1" :key="index">正常</el-tag>
                            <el-tag v-if="row.hobbydata == 0" :key="index">隐藏</el-tag>
                            <el-tag v-if="row.hobbydata == 2" :key="index">推荐</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="hobbysdata" label="多选" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <span v-for="(item,index) in row.hobbysdata" :key="index">
                                <el-tag v-if="item == 1" :key="index">正常</el-tag>
                                <el-tag v-if="item == 0" :key="index">隐藏</el-tag>
                                <el-tag v-if="item == 2" :key="index">推荐</el-tag>
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="daterange" label="日期范围" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.daterange" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="datetimierange" label="日期时间范围" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.datetimierange" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="timerange" label="时间范围" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.timerange" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="decimal_price" label="金额小数" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="address_region" label="地区选址" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.address_region" :key="index">{{item}}</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:ceshi:edit')">修改</el-link>
                            <el-popconfirm title="确定要删除此测试吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:ceshi:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改测试':'添加测试'" :visible.sync="showEdit" width="800px" :destroy-on-close="true"
            :lock-scroll="false" @close="closeDialog">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                <el-form-item label="金额（元）:" prop="title_unit">
                    <el-input v-model="editForm.title_unit" placeholder="请输入金额（元）" clearable />
                </el-form-item>

                <el-form-item label="手机号:" prop="phone">
                    <el-input-number v-model="editForm.phone" :controls="false" controls-position="right" :min="0"
                        placeholder="请输入手机号" class="ele-fluid ele-text-left" clearable />
                </el-form-item>

                <el-form-item label="标题:" prop="title">
                    <el-input v-model="editForm.title" placeholder="请输入标题" clearable />
                </el-form-item>
                <el-form-item label="商城数量:" prop="store_num">
                    <el-input-number v-model="editForm.store_num" controls-position="right" :controls="false"
                        :precision="0" class="ele-fluid ele-text-left" placeholder="请输入商城数量" clearable />
                </el-form-item>

                <el-form-item label="状态:" prop="status">
                    <el-switch v-model="editForm.status" active-text="是" inactive-text="否" :active-value="1"
                        :inactive-value="0" />

                </el-form-item>

                <el-form-item label="状态:" prop="show_status">
                    <el-switch v-model="editForm.show_status" active-text="是" inactive-text="否" :active-value="1"
                        :inactive-value="0" />

                </el-form-item>

                <el-form-item label="状态:" prop="siteswitch">
                    <el-switch v-model="editForm.siteswitch" active-text="是" inactive-text="否" :active-value="1"
                        :inactive-value="0" />

                </el-form-item>

                <el-form-item label="小数输入框:" prop="flot_price">
                    <el-input-number v-model="editForm.flot_price" controls-position="right" :min="0" :controls="false"
                        :precision="4" class="ele-fluid ele-text-left" placeholder="请输入小数输入框" clearable />
                </el-form-item>

                <el-form-item label="文本框:" prop="area_text">
                    <el-input type="textarea" v-model="editForm.area_text" placeholder="请输入文本框" clearable />
                </el-form-item>

                <el-form-item label="时间选择器:" prop="datetime">
                    <el-time-select v-model="editForm.datetime" placeholder="选择时间选择器">
                    </el-time-select>

                </el-form-item>

                <el-form-item label="日期组件:" prop="date_info">
                    <el-date-picker v-model="editForm.date_info" align="right" type="date" placeholder="选择日期组件"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>

                </el-form-item>

                <el-form-item label="日期时间组件:" prop="timestamp">
                    <el-date-picker v-model="editForm.timestamp" type="datetime" placeholder="选择日期时间组件" size="small"
                        value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>

                </el-form-item>

                <el-form-item label="时间日期其他:" prop="datetimessss">
                    <el-date-picker v-model="editForm.datetimessss" type="datetime" placeholder="选择时间日期其他" size="small"
                        value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>

                </el-form-item>

                <el-form-item label="会员id单选:" prop="user_id">
                    <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                            :value="item.id">
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label="多id合集:" prop="user_ids">
                    <el-select v-model="editForm.user_ids" multiple placeholder="请选择">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                            :value="item.id.toString()">
                        </el-option>
                    </el-select>

                </el-form-item>


                <el-form-item label="管理员id:" prop="admin_id">
                    <el-select v-model="editForm.admin_id" filterable placeholder="请选择">
                        <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname+item.mobile"
                            :value="item.id">
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label="管理员id多选:" prop="admin_ids">
                    <el-select v-model="editForm.admin_ids" multiple placeholder="请选择">
                        <el-option v-for="item in admin_list" :key="item.id" :label="item.nickname+item.mobile"
                            :value="item.id.toString()">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="关联表id:" prop="store_goods_category_id">
                    <el-select v-model="editForm.store_goods_category_id" filterable placeholder="请选择">
                        <el-option v-for="item in store_goods_category_list" :key="item.id" :label="item.cate_name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="分类时间:" prop="store_goods_category_time_id">
                    <el-select v-model="editForm.store_goods_category_time_id" filterable placeholder="请选择">
                        <el-option v-for="item in store_goods_category_list" :key="item.id" :label="item.add_time"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="关联表id多选:" prop="store_goods_category_ids">
                    <el-select v-model="editForm.store_goods_category_ids" multiple filterable placeholder="请选择">
                        <el-option v-for="item in store_goods_category_list" :key="item.id" :label="item.cate_name"
                            :value="item.id.toString()">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="权重:" prop="sort">
                    <el-input-number v-model="editForm.sort" controls-position="right" :controls="false" :precision="0"
                        class="ele-fluid ele-text-left" placeholder="请输入权重" clearable />
                </el-form-item>

                <el-form-item label="单图:" prop="smallimage">
                    <ele-uploadimage :limit="1" v-model="editForm.smallimage"></ele-uploadimage>

                </el-form-item>

                <el-form-item label="多图:" prop="smallimages">
                    <ele-uploadimage :limit="9" v-model="editForm.smallimages"></ele-uploadimage>

                </el-form-item>

                <el-form-item label="单文件:" prop="attachfile">
                    <ele-upload-resource-other :limit="1" v-model="editForm.attachfile"></ele-upload-resource-other>

                </el-form-item>

                <el-form-item label="多文件:" prop="attachfiles">
                    <ele-upload-resource-other :limit="9" v-model="editForm.attachfiles"></ele-upload-resource-other>

                </el-form-item>


                <el-form-item label="当头像:" prop="miniavatar">
                    <ele-uploadimage :limit="1" v-model="editForm.miniavatar"></ele-uploadimage>

                </el-form-item>

                <el-form-item label="多头像:" prop="miniavatars">
                    <ele-uploadimage :limit="9" v-model="editForm.miniavatars"></ele-uploadimage>

                </el-form-item>

                <el-form-item label="富文本:" prop="maincontent">
                    <tinymce-editor v-model="editForm.maincontent" :init="initEditor" />
                </el-form-item>
                <el-form-item label="单选:" prop="timelist">
                    <el-select v-model="editForm.timelist" filterable placeholder="请选择单选">
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="隐藏" value="0"></el-option>
                        <el-option label="推荐" value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="多选下拉:" prop="timeslist">
                    <el-select v-model="editForm.timeslist" multiple filterable placeholder="请选择多选下拉">
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="隐藏" value="0"></el-option>
                        <el-option label="推荐" value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="单选:" prop="hobbydata">
                    <el-select v-model="editForm.hobbydata" filterable placeholder="请选择单选">
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="隐藏" value="0"></el-option>
                        <el-option label="推荐" value="2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="多选:" prop="hobbysdata">
                    <el-select v-model="editForm.hobbysdata" multiple filterable placeholder="请选择多选">
                        <el-option label="正常" value="1"></el-option>
                        <el-option label="隐藏" value="0"></el-option>
                        <el-option label="推荐" value="2"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="日期范围:" prop="daterange">
                    <el-date-picker v-model="editForm.daterange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>


                <el-form-item label="日期时间范围:" prop="datetimierange">
                    <el-date-picker v-model="editForm.datetimierange" type="datetimerange" start-placeholder="开始日期"
                        end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                    </el-date-picker>
                </el-form-item>


                <el-form-item label="时间范围:" prop="timerange">
                    <el-time-picker is-range v-model="editForm.timerange" range-separator="至" start-placeholder="开始时间"
                        end-placeholder="结束时间" placeholder="选择时间范围" value-format="hh:mm:ss">
                    </el-time-picker>
                </el-form-item>

                <el-form-item label="金额小数:" prop="decimal_price">
                    <el-input-number v-model="editForm.decimal_price" controls-position="right" :min="0"
                        :controls="false" :precision="4" class="ele-fluid ele-text-left" placeholder="请输入金额小数"
                        clearable />
                </el-form-item>

                <el-form-item label="地图选址:" prop="city_map">
                    <ele-upload-map v-model="editForm.city_map"></ele-upload-map>
                </el-form-item>


                <el-form-item label="地区选址:" prop="address_region">
                    <el-cascader v-model="editForm.address_region" :options="cityData.cityDataLabel" clearable
                        popper-class="ele-pop-wrap-higher" />
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";

    import EleUploadimage from '@/components/EleUploadimage'
    import EleUploadResourceOther from '@/components/EleUploadResourceOther'
    import cityData from '@/utils/cityData'
    import TinymceEditor from '@/components/TinymceEditor'
    import EleUploadMap from '@/components/EleUploadMap'

    export default {
        name: "SysCeshi",
        components: {
            EleUploadimage,
            EleUploadResourceOther,
            TinymceEditor,
            EleUploadMap,
        },
        data() {
            return {
                cityData: cityData,
                table: {
                    url: '/ceshi/ceshi/index',
                    where: {
                        "user_ids": [],
                        "admin_ids": [],
                        "store_goods_category_ids": [],
                        "smallimage": [],
                        "smallimages": [],
                        "attachfile": [],
                        "attachfiles": [],
                        "miniavatar": [],
                        "miniavatars": [],
                        "timeslist": [],
                        "hobbysdata": [],
                        "daterange": [],
                        "datetimierange": [],
                        "timerange": [],
                        "address_region": []
                    }
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {
                    "user_ids": [],
                    "admin_ids": [],
                    "store_goods_category_ids": [],
                    "smallimage": [],
                    "smallimages": [],
                    "attachfile": [],
                    "attachfiles": [],
                    "miniavatar": [],
                    "miniavatars": [],
                    "timeslist": [],
                    "hobbysdata": [],
                    "daterange": [],
                    "datetimierange": [],
                    "timerange": [],
                    "address_region": []
                }, // 表单数据
                editFormTemp:{
                    "user_ids": [],
                    "admin_ids": [],
                    "store_goods_category_ids": [],
                    "smallimage": [],
                    "smallimages": [],
                    "attachfile": [],
                    "attachfiles": [],
                    "miniavatar": [],
                    "miniavatars": [],
                    "timeslist": [],
                    "hobbysdata": [],
                    "daterange": [],
                    "datetimierange": [],
                    "timerange": [],
                    "address_region": []
                },
                admin_list: [],
                user_list: [],
                search_show: false,
                store_goods_category_list: [],
                editRules: { // 表单验证规则
                    phone: [{
                            required: true,
                            message: '请选择手机号',
                            trigger: 'blur'
                        },
                        {
                            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                            message: '手机号格式不对',
                            trigger: 'blur'
                        }
                    ],
                    store_num: [{
                        required: true,
                        message: '请输入商城数量',
                        trigger: 'blur'
                    }],
                    area_text: [{
                        required: true,
                        message: '请输入文本框',
                        trigger: 'blur'
                    }],


                    datetime: [{
                        required: true,
                        message: '请选择时间选择器',
                        trigger: 'blur'
                    }],


                    date_info: [{
                        required: true,
                        message: '请选择日期组件',
                        trigger: 'blur'
                    }],


                    timestamp: [{
                        required: true,
                        message: '请选择日期时间组件',
                        trigger: 'blur'
                    }],


                    datetimessss: [{
                        required: true,
                        message: '请选择时间日期其他',
                        trigger: 'blur'
                    }],


                    user_id: [{
                        required: true,
                        message: '请选择会员id单选',
                        trigger: 'blur'
                    }],


                    user_ids: [{
                        required: true,
                        message: '请选择多id合集',
                        trigger: 'blur'
                    }],


                    admin_id: [{
                        required: true,
                        message: '请选择管理员id',
                        trigger: 'blur'
                    }],


                    admin_ids: [{
                        required: true,
                        message: '请选择管理员id多选',
                        trigger: 'blur'
                    }],


                    store_goods_category_id: [{
                        required: true,
                        message: '请选择关联表id',
                        trigger: 'blur'
                    }],


                    store_goods_category_time_id: [{
                        required: true,
                        message: '请选择分类时间',
                        trigger: 'blur'
                    }],


                    store_goods_category_ids: [{
                        required: true,
                        message: '请选择关联表id多选',
                        trigger: 'blur'
                    }],


                    sort: [{
                        required: true,
                        message: '请输入权重',
                        trigger: 'blur'
                    }],


                    smallimage: [{
                        required: true,
                        message: '请上传单图',
                        trigger: 'blur'
                    }],


                    smallimages: [{
                        required: true,
                        message: '请上传多图',
                        trigger: 'blur'
                    }],


                    attachfile: [{
                        required: true,
                        message: '请上传单文件',
                        trigger: 'blur'
                    }],


                    attachfiles: [{
                        required: true,
                        message: '请上传多文件',
                        trigger: 'blur'
                    }],


                    miniavatar: [{
                        required: true,
                        message: '请上传当头像',
                        trigger: 'blur'
                    }],


                    miniavatars: [{
                        required: true,
                        message: '请上传多头像',
                        trigger: 'blur'
                    }],


                    maincontent: [{
                        required: true,
                        message: '请输入富文本',
                        trigger: 'blur'
                    }],


                    timelist: [{
                        required: true,
                        message: '请选择单选',
                        trigger: 'blur'
                    }],


                    timeslist: [{
                        required: true,
                        message: '请选择多选下拉',
                        trigger: 'blur'
                    }],


                    hobbydata: [{
                        required: true,
                        message: '请选择单选',
                        trigger: 'blur'
                    }],


                    hobbysdata: [{
                        required: true,
                        message: '请选择多选',
                        trigger: 'blur'
                    }],


                    daterange: [{
                        required: true,
                        message: '请选择日期范围',
                        trigger: 'blur'
                    }],


                    datetimierange: [{
                        required: true,
                        message: '请选择日期时间范围',
                        trigger: 'blur'
                    }],


                    timerange: [{
                        required: true,
                        message: '请选择时间范围',
                        trigger: 'blur'
                    }],



                    city_map: [{
                        required: true,
                        message: '请选择地图选址',
                        trigger: 'blur'
                    }],


                    address_region: [{
                        required: true,
                        message: '请选择地区选址',
                        trigger: 'blur'
                    }],


                    create_time: [{
                        required: true,
                        message: '请选择创建时间',
                        trigger: 'blur'
                    }],


                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
            initEditor() {
                return {
                    height: 400,
                    file_picker_callback: this.file_picker_callback,
                    skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                        '/tinymce/skins/ui/oxide',
                    content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' :
                        '/tinymce/skins/content/default/content.css',
                    images_upload_handler: (blobInfo, success, error) => {
                        let file = blobInfo.blob();
                        // 使用axios上传
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        this.$http.post('/upload/uploadImage', formData).then(res => {
                            if (res.data.code == 0) {
                                success(res.data.data);
                            } else {
                                error(res.data.msg);
                            }
                        }).catch(e => {
                            error(e.message);
                        });
                    }
                };
            }
        },
        mounted() {

            this.userAllList();
            this.adminAllList();
            this.StoreGoodsCategoryAllList();
        },
        methods: {
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/ceshi/ceshi/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        // this.editForm.user_ids = ;
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                         }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/ceshi/ceshi/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的测试吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/ceshi/ceshi/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/ceshi/ceshi/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 获取全部会员 */
            userAllList() {
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /* 获取全部管理员 */
            adminAllList() {
                this.$http.post('/admin/admin/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.admin_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /* 导出数据Excel */
            exportExcel() {
                let info = JSON.parse(JSON.stringify(this.table.where));
                this.$http
                    .get("/ceshi/ceshi/exportExcel", info)
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            // window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            //查询其他信息
            StoreGoodsCategoryAllList() {
                this.$http.post('/store/StoreGoodsCategory/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.store_goods_category_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },

            /**
     * 更改状态

     */
            editStatus(row, name) {
                const loading = this.$loading({
                    lock: true
                });
                let data = {
                    id: row.id,
                    name: name,
                    value: row[name],
                }
                this.$http.post("/ceshi/ceshi/status", data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row[name] = !row[name] ? 1 : 0;
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
